import { combineReducers } from "redux";
import { config } from "./config";
import { gameData } from "./game-data";
import { gameProgress } from "./game-progress";
import { pageWaitingRoom } from "./page-waiting-room";
import { userProgress } from "./user-progress";

export const rootReducer = combineReducers({
    config,
    gameData,
    gameProgress,
    userProgress,
    pageWaitingRoom,
});
